import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import BrowserStore from 'store2';
import { browserHistory } from 'react-router';
import { authDeleteUser } from '../../actions/auth';

const REQUEST_STRING = 'DELETE';

const AlertUI = ({ onClose, deleteUser }) => {
  const [deleteConfirm, setDeleteConfirm] = useState('');
  const [isInvalid, setIsInvalid] = useState(false);
  const [contentIndex, setContentIndex] = useState(0);
  const validClass = isInvalid ? 'is-invalid' : '';
  let successCheckInterval = null;

  const confirm = () => {
    if (deleteConfirm !== REQUEST_STRING) {
      setIsInvalid(true);
      return;
    }
    setContentIndex(1);
    successCheckInterval = setInterval(() => {
      const deletedResult = BrowserStore.session.get('user_deleted');
      if (!deletedResult) {
        return;
      }
      setContentIndex(2);
      successCheckInterval = null;
      BrowserStore.session.remove('user_deleted');
      setTimeout(() => {
        browserHistory.push('/livecams');
        onClose();
      }, 5000);
    }, 1000);
    deleteUser();
  };

  const content = [
    (
      <div>
        <h1 className="mb-2">Are you sure?</h1>
        Are you sure you want to delete your account? This cannot be undone. If you are sure, type the
        word &quot;{REQUEST_STRING}&quot; in all caps in the field below.
        <div>
          <input
            className={`form-control mt-3 ${validClass}`}
            onChange={(e) => {
              const val = e.currentTarget.value;
              setDeleteConfirm(val);
              if (val === REQUEST_STRING) {
                setIsInvalid(false);
              }
            }}
            value={deleteConfirm}
          />
          <div className="invalid-feedback">
            Please type {REQUEST_STRING}
          </div>
        </div>
        <div className="mt-3">
          <button
            className="btn btn-danger"
            label="Confirm"
            onClick={confirm}
          >
            Confirm
          </button>
          <button
            label="Cancel"
            className="btn btn-outline-dark ml-2"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    ),
    (
      <div>
        <h1 className="mb-2">Deleting Account</h1>
        Your account is being deleted. Please wait...
      </div>
    ),
    (
      <div>
        <h1 className="mb-2">Account Successfully Deleted</h1>
        Your account has been deleted! Redirecting you to explore.org home page.
      </div>
    ),
  ];

  return (
    <div className="react-confirm-alert-body">
      {content[contentIndex]}
    </div>
  );
};
const DeleteAccount = ({ isDeleting, userDeleted, deleteUser }) => {
  const onClick = () => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <AlertUI
          onClose={onClose}
          isDeleting={isDeleting}
          userDeleted={userDeleted}
          deleteUser={deleteUser}
        />
      ),
    });
  };

  return (
    <div className="btn btn-danger mt-2" onClick={onClick}>Delete Account</div>
  );
};

const mapStateToProps = (state) => {
  return {
    isDeleting: state.auth.isDeleting,
    userDeleted: state.auth.deleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteUser: () => dispatch(authDeleteUser()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccount);
